module.exports = __webpack_public_path__ + "media/shock.c23f222e.mp3";